var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6664 21.6002L13.3664 15.3002C12.8664 15.7002 12.2914 16.0169 11.6414 16.2502C10.9914 16.4836 10.2997 16.6002 9.56641 16.6002C7.74974 16.6002 6.21241 15.9709 4.95441 14.7122C3.69641 13.4536 3.06707 11.9162 3.06641 10.1002C3.06641 8.28355 3.69574 6.74622 4.95441 5.48822C6.21307 4.23022 7.75041 3.60089 9.56641 3.60022C11.3831 3.60022 12.9204 4.22955 14.1784 5.48822C15.4364 6.74689 16.0657 8.28422 16.0664 10.1002C16.0664 10.8336 15.9497 11.5252 15.7164 12.1752C15.4831 12.8252 15.1664 13.4002 14.7664 13.9002L21.0664 20.2002L19.6664 21.6002ZM9.56641 14.6002C10.8164 14.6002 11.8791 14.1626 12.7544 13.2872C13.6297 12.4119 14.0671 11.3496 14.0664 10.1002C14.0664 8.85022 13.6287 7.78755 12.7534 6.91222C11.8781 6.03689 10.8157 5.59955 9.56641 5.60022C8.31641 5.60022 7.25374 6.03789 6.37841 6.91322C5.50307 7.78855 5.06574 8.85089 5.06641 10.1002C5.06641 11.3502 5.50407 12.4129 6.37941 13.2882C7.25474 14.1636 8.31707 14.6009 9.56641 14.6002Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0f531ea2492ee20e9566b4eef67238a1.svg";
export { ForwardRef as ReactComponent };